import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { RootState } from '.';
import { constants } from '../../config';
import { AddressInfo } from '../../pages/orders/addreess_select_page';
import { Product, ProductVariants } from '../models/product_list_response';
import { PurchaseOrder } from '../models/purchase_order_response';
import { applyCouponService, placeOrderService } from '../services/cart.service';

export const applyCoupon = createAsyncThunk(
  'cart/applyCoupon',
  async (
    payload: {
      shopperAccount: { shopperAccountId: string; phoneNumber: string; fullName: string };
      couponCode: string | null,
      merchantStoreId: string;
      fulfilmentType: string;
    },
    thunkAPI,
  ) => {
    const state: any = thunkAPI.getState();
    const products: Product[] = state.cartReducer.cartItems;

    const applyCouponResponse = await applyCouponService({
      fulfilmentType: payload.fulfilmentType,
      orderTimestamp: new Date().toISOString(),
      couponCode: payload.couponCode,
      shopperAccount: {
        shopperAccountId: payload.shopperAccount.shopperAccountId,
        phoneNumber: payload.shopperAccount.phoneNumber,
        fullName: payload.shopperAccount.fullName,
      },
      shippingAddress:
        state.cartReducer.addressInfo.Address1 != null
          ? {
              addressLine1: state.cartReducer.addressInfo.Address1,
              addressLine2: state.cartReducer.addressInfo.Address2,
              landmark: state.cartReducer.addressInfo.Landmark,
              locality: state.cartReducer.addressInfo.Locality,
              city: state.cartReducer.addressInfo.City,
              contactNumber: state.cartReducer.addressInfo.contactNumber,
              alternateContactNumber: state.cartReducer.addressInfo.alternateContactNumber,
            }
          : null,
      merchantStoreId: payload.merchantStoreId,
      products: products,
      subTotal: state.cartReducer.cartSubTotalAmount,
      tax: 0,
      couponDiscount: 0,
      total: state.cartReducer.cartTotalAmount,
      notes: state.cartReducer.addressInfo.notes,
    });
    if (applyCouponResponse.isSuccessful) {
      return applyCouponResponse.data;
    } else {
      if (applyCouponResponse.message?.response?.data?.message?.length > 0) {
        thunkAPI.rejectWithValue(applyCouponResponse.message.response.data.message);
        throw new Error(applyCouponResponse.message.response.data.message);
      } else {
        thunkAPI.rejectWithValue('Unable to apply coupon.');
        throw new Error('Unable to apply coupon.');
      }
    }
  },
);

export const placeOrder = createAsyncThunk(
  'cart/placeOrder',
  async (
    payload: {
      shopperAccount: { shopperAccountId: string; phoneNumber: string; fullName: string };
      couponCode: string | null,
      merchantStoreId: string;
      fulfilmentType: string;
    },
    thunkAPI,
  ) => {
    const state: any = thunkAPI.getState();
    const products: Product[] = state.cartReducer.cartItems;
    // products.forEach((p: Product) => );
    const placeOrderResponse = await placeOrderService({
      fulfilmentType: payload.fulfilmentType,
      orderTimestamp: new Date().toISOString(),
      couponCode: payload.couponCode,
      shopperAccount: {
        shopperAccountId: payload.shopperAccount.shopperAccountId,
        phoneNumber: payload.shopperAccount.phoneNumber,
        fullName: payload.shopperAccount.fullName,
      },
      shippingAddress:
        state.cartReducer.addressInfo.Address1 != null
          ? {
              addressLine1: state.cartReducer.addressInfo.Address1,
              addressLine2: state.cartReducer.addressInfo.Address2,
              landmark: state.cartReducer.addressInfo.Landmark,
              locality: state.cartReducer.addressInfo.Locality,
              city: state.cartReducer.addressInfo.City,
              contactNumber: state.cartReducer.addressInfo.contactNumber,
              alternateContactNumber: state.cartReducer.addressInfo.alternateContactNumber,
            }
          : null,
      merchantStoreId: payload.merchantStoreId,
      products: products,
      subTotal: state.cartReducer.cartSubTotalAmount,
      tax: 0,
      couponDiscount: 0,
      total: state.cartReducer.cartTotalAmount,
      notes: state.cartReducer.addressInfo.notes,
    });
    if (placeOrderResponse.isSuccessful) {
      return placeOrderResponse.data;
    } else {
      if (placeOrderResponse.message?.response?.data?.message?.length > 0) {
        thunkAPI.rejectWithValue(placeOrderResponse.message.response.data.message);
        throw new Error(placeOrderResponse.message.response.data.message);
      } else {
        thunkAPI.rejectWithValue('Unable to place order.');
        throw new Error('Unable to place order.');
      }
    }
  },
);

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    isLoading: false,
    cartItems: <Product[]>[],
    cartItemCount: 0,
    cartSubTotalAmount: 0.0,
    coupon: '',
    cartTotalAmount: 0.0,
    addressInfo: <AddressInfo>{},
    orderPlaced: false,
    placedOrderInfo: <PurchaseOrder>{},
    appliedCouponMessage: <string | null>null,
    applyCouponLoading: <boolean>false,
    applyCouponError: <boolean>false,
    appliedCouponDiscountAmount: 0,
  },
  reducers: {
    addToCart(state, action) {
      const itemIndex = state.cartItems.findIndex(
        (item: Product) => item.storeProductId === action.payload.product.storeProductId,
      );

      if (action.payload.product.haveVariants) {
        const variantIndex = action.payload.product.productVariants.findIndex(
          (variats: ProductVariants) =>
            variats.id === action.payload.selectedVariantId ?? action.payload.storeProductId,
        );

        const newitemIndex = state.cartItems.findIndex(
          (item: Product) => item.storeProductId === action.payload.product.storeProductId,
        );

        const variantInCartIndex =
          newitemIndex != -1
            ? state.cartItems[newitemIndex].productVariants.findIndex(
                (item: ProductVariants) => item.id === action.payload.selectedVariantId,
              )
            : -1;

        console.log('***************************');
        console.log(newitemIndex);
        console.log(variantInCartIndex);
        console.log(action.payload.product.selectedVariantId);
        console.log('***************************');

        if (newitemIndex !== -1 && variantInCartIndex !== -1) {
          if (
            action.payload.product.productVariants[variantIndex].quantity >
            state.cartItems[newitemIndex].productVariants[variantInCartIndex].cartQuantity
          ) {
            state.cartItems[newitemIndex].productVariants[variantInCartIndex].cartQuantity += 1;
          } else {
            toast.dismiss();
            toast.error('Stock unavailable', {
              position: 'bottom-center',
            });
          }
        } else {
          if (action.payload.product.productVariants[variantIndex].quantity > 0) {
            if (variantInCartIndex == -1 && newitemIndex != -1) {
              const newVariantCartItem = { ...action.payload.product.productVariants[variantIndex], cartQuantity: 1 };
              state.cartItems[itemIndex].productVariants.push(newVariantCartItem);
              toast(`🛒 ${action.payload.product.productVariants[variantIndex].variantName} added to cart L1`, {
                position: 'bottom-center',
                hideProgressBar: true,
                autoClose: 800,
              });
            } else {
              const newCartItem = {
                ...action.payload.product,
                productVariants: [{ ...action.payload.product.productVariants[variantIndex], cartQuantity: 1 }],
              };
              state.cartItems.push(newCartItem);
              toast(`🛒 ${action.payload.product.productVariants[variantIndex].variantName} added to cart`, {
                position: 'bottom-center',
                hideProgressBar: true,
                autoClose: 800,
              });
            }
          } else {
            toast.dismiss();
            toast.error('Stock unavailable', {
              position: 'bottom-center',
            });
          }
        }
      } else {
        if (itemIndex !== -1) {
          if (action.payload.product.quantity > state.cartItems[itemIndex].cartQuantity) {
            state.cartItems[itemIndex].cartQuantity += 1;
          } else {
            toast.dismiss();
            toast.error('Stock unavailable', {
              position: 'bottom-center',
            });
          }
        } else {
          if (action.payload.product.quantity > 0) {
            toast(`🛒 ${action.payload.product.productName} added to cart`, {
              position: 'bottom-center',
              hideProgressBar: true,
              autoClose: 800,
            });
            const newCartItem = { ...action.payload.product, cartQuantity: 1 };
            state.cartItems.push(newCartItem);
          } else {
            toast.dismiss();
            toast.error('Stock unavailable', {
              position: 'bottom-center',
            });
          }
        }
      }

      state.cartItemCount = state.cartItems.length;
      const storeSlug = action.payload.storeSlug;
      const data = <any>{};
      data[storeSlug] = state.cartItems;
      localStorage.setItem(constants.CART_ITEMS_KEY, JSON.stringify(data));
    },
    removeFromCart(state, action) {
      console.log(action.payload);
      const itemIndex = state.cartItems.findIndex(
        (item: Product) => item.storeProductId === action.payload.storeProductId,
      );
      const product = state.cartItems[itemIndex];
      console.log(action.payload.selectedVariantId);
      if (product.haveVariants) {
        const variantIndex = product.productVariants.findIndex((v) => v.id == action.payload.selectedVariantId);
        if (variantIndex != -1) {
          state.cartItems[itemIndex].productVariants[variantIndex].cartQuantity -= 1;
          if (state.cartItems[itemIndex].productVariants[variantIndex].cartQuantity == 0) {
            state.cartItems[itemIndex].productVariants.splice(variantIndex, 1);
            if (state.cartItems[itemIndex].productVariants.length == 0) {
              state.cartItems.splice(itemIndex, 1);
            }
          }
        }
      } else {
        if (state.cartItems[itemIndex].cartQuantity > 1) {
          state.cartItems[itemIndex].cartQuantity -= 1;
        } else {
          state.cartItems[itemIndex].cartQuantity = 0;
          state.cartItems.splice(itemIndex, 1);
        }
      }
      state.cartItemCount = state.cartItems.length;
      const storeSlug = action.payload.storeSlug;
      const data = <any>{};
      data[storeSlug] = state.cartItems;
      localStorage.setItem(constants.CART_ITEMS_KEY, JSON.stringify(data));
    },
    deleteFromCart(state, action) {
      const itemIndex = state.cartItems.findIndex(
        (item: Product) => item.storeProductId === action.payload.product.storeProductId,
      );
      state.cartItems[itemIndex].cartQuantity = 0;
      state.cartItems.splice(itemIndex, 1);
      state.cartItemCount = state.cartItems.length;
      const storeSlug = action.payload.storeSlug;
      const data = <any>{};
      data[storeSlug] = state.cartItems;
      localStorage.setItem(constants.CART_ITEMS_KEY, JSON.stringify(data));
    },
    restoreCart(state, action) {
      const restoreCartItems = localStorage.getItem(constants.CART_ITEMS_KEY);
      const storeSlug = action.payload.storeSlug;
      if (restoreCartItems) {
        const cartItems = JSON.parse(restoreCartItems)[storeSlug];
        state.cartItems = cartItems ?? [];
        state.cartItemCount = state.cartItems.length;
      }
    },
    setCoupon(state, action) {
      state.coupon = action.payload.discount;
    },
    calculateTotal(state, action) {
      let totalAmount = 0;
      state.cartItems.forEach((product: Product) => {
        if (product.haveVariants) {
          product.productVariants.forEach((v: ProductVariants) => (totalAmount += v.cartQuantity * v.sellingPrice));
        } else {
          totalAmount += product.cartQuantity * product.sellingPrice;
        }
      });
      state.cartSubTotalAmount = totalAmount;
      state.cartTotalAmount = totalAmount;
    },
    updateCartQuantity(state, action) {
      const itemIndex = state.cartItems.findIndex(
        (item: Product) => item.storeProductId === action.payload.product.storeProductId,
      );
      const product = state.cartItems[itemIndex];
      if (product.haveVariants) {
        const variantIndex = product.productVariants.findIndex((v) => v.id == action.payload.selectedVariantId);
        if (
          state.cartItems[itemIndex].productVariants[variantIndex].quantity >= action.payload.updatedQuantity &&
          action.payload.updatedQuantity > 0
        ) {
          state.cartItems[itemIndex].productVariants[variantIndex].cartQuantity = action.payload.updatedQuantity;
        } else if (action.payload.updatedQuantity === 0 || action.payload.updatedQuantity === '') {
          state.cartItems[itemIndex].productVariants[variantIndex].cartQuantity = 0;
          state.cartItems.splice(itemIndex, 1);
        }
      } else {
        if (
          state.cartItems[itemIndex].quantity >= action.payload.updatedQuantity &&
          action.payload.updatedQuantity > 0
        ) {
          state.cartItems[itemIndex].cartQuantity = action.payload.updatedQuantity;
        } else if (action.payload.updatedQuantity === 0 || action.payload.updatedQuantity === '') {
          state.cartItems[itemIndex].cartQuantity = 0;
          state.cartItems.splice(itemIndex, 1);
        }
      }

      state.cartItemCount = state.cartItems.length;
      const storeSlug = action.payload.storeSlug;
      const data = <any>{};
      data[storeSlug] = state.cartItems;
      localStorage.setItem(constants.CART_ITEMS_KEY, JSON.stringify(data));
    },
    clearCart(state, action) {
      state.cartItems = [];
      state.cartItemCount = 0;
      state.cartSubTotalAmount = 0.0;
      state.cartTotalAmount = 0.0;
      state.coupon = '';
      state.orderPlaced = false;
      localStorage.removeItem(constants.CART_ITEMS_KEY);
    },
    saveAddressInfo(state, action) {
      state.addressInfo = action.payload;
    },
    clearCoupon(state, action) {
      state.appliedCouponDiscountAmount = 0;
      state.appliedCouponMessage = null;
    },
  },
  extraReducers: {
    [placeOrder.pending.type]: (state, action) => {
      state.orderPlaced = false;
      state.isLoading = true;
    },
    [placeOrder.fulfilled.type]: (state, action) => {
      state.isLoading = false;
      state.orderPlaced = true;
      state.placedOrderInfo = action.payload.data;
    },
    [placeOrder.rejected.type]: (state, action) => {
      state.isLoading = false;
      state.orderPlaced = false;
      toast.error(action.error.message, { position: 'bottom-center' });
    },
    [applyCoupon.pending.type]: (state, action) => {
      state.appliedCouponMessage = null;
      state.applyCouponLoading = true;
      state.applyCouponError = false;
    },
    [applyCoupon.fulfilled.type]: (state, action) => {
      state.appliedCouponMessage = action.payload.data.message;
      state.applyCouponError = !action.payload.data.isEligible;
      state.appliedCouponDiscountAmount = action.payload.data.discountAmount ?? 0;
      state.applyCouponLoading = false;
    },
    [applyCoupon.rejected.type]: (state, action) => {
      state.appliedCouponMessage = null;
      state.applyCouponError = true;
      state.applyCouponLoading = false;
      toast.error(action.error.message, { position: 'bottom-center' });
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  deleteFromCart,
  updateCartQuantity,
  restoreCart,
  clearCart,
  setCoupon,
  calculateTotal,
  saveAddressInfo,
  clearCoupon,
} = cartSlice.actions;

export default cartSlice.reducer;
